/**
 * assets/pdp-sliders.js
 *
 * Slick carousel init for the PDP's photo/testimonial sliders (social
 * proof photos + testimonials, reviews photos). Requires jQuery + Slick,
 * loaded only on the product template (see layout/theme.liquid). Each
 * slider's prev/next buttons are plain elements outside Slick's own
 * markup so they can be styled to match the rest of the PDP exactly;
 * Slick's `asNavFor`-free API methods (slickPrev/slickNext) drive them.
 */
(function () {
  if (window.__pdpSlidersLoaded) return;
  window.__pdpSlidersLoaded = true;

  function initSlider($, selector, options) {
    $(selector).each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) return;

      $slider.slick(options);

      var $wrapper = $slider.closest('[data-slider-wrapper]');
      var $prev = $wrapper.find('[data-slider-prev]');
      var $next = $wrapper.find('[data-slider-next]');

      $prev.on('click', function () {
        $slider.slick('slickPrev');
      });
      $next.on('click', function () {
        $slider.slick('slickNext');
      });
    });
  }

  function init() {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;
    var $ = window.jQuery;

    initSlider($, '[data-photo-slider]', {
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3500,
      pauseOnHover: true,
      speed: 600,
      responsive: [
        { breakpoint: 980, settings: { slidesToShow: 3 } },
        { breakpoint: 700, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1.3, arrows: false } }
      ]
    });

    initSlider($, '[data-testimonial-slider]', {
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      speed: 600,
      responsive: [
        { breakpoint: 980, settings: { slidesToShow: 2 } },
        { breakpoint: 700, settings: { slidesToShow: 1, arrows: false } }
      ]
    });
  }

  // Deferred scripts run during the "interactive" phase, after parsing
  // but before DOMContentLoaded fires, so document.readyState is never
  // "loading" here even though this script itself is deferred — a
  // readyState check would (incorrectly) run init() immediately, before
  // jquery.min.js/slick.min.js (loaded later in the document, from
  // layout/theme.liquid) have necessarily finished. Always defer to the
  // event itself instead.
  document.addEventListener('DOMContentLoaded', init);
})();
